import { render, staticRenderFns } from "./ServiceHallByDept.vue?vue&type=template&id=61975ccc&scoped=true&"
import script from "./ServiceHallByDept.vue?vue&type=script&lang=js&"
export * from "./ServiceHallByDept.vue?vue&type=script&lang=js&"
import style0 from "./ServiceHallByDept.vue?vue&type=style&index=0&id=61975ccc&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61975ccc",
  null
  
)

export default component.exports